/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_Invite_Email_SentInputs */

const cs_client_portal_invite_email_sent = /** @type {(inputs: Client_Portal_Invite_Email_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail s pozvánkou byl odeslán.`)
};

const en_client_portal_invite_email_sent = /** @type {(inputs: Client_Portal_Invite_Email_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite email was sent.`)
};

/**
* | output |
* | --- |
* | "Invite email was sent." |
*
* @param {Client_Portal_Invite_Email_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_invite_email_sent = /** @type {((inputs?: Client_Portal_Invite_Email_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_Invite_Email_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_invite_email_sent(inputs)
	return cs_client_portal_invite_email_sent(inputs)
});